import React from 'react';
import './App.css';
import { HashRouter as Router, Route } from 'react-router-dom';
import CacheRoute from 'react-router-cache-route';

import MainCmp from './components/MainCmp';
import LoginCmp from './components/LoginCmp';
import TermsCmp from './components/TermsCmp';
import PrivateCmp from './components/PrivateCmp';
import JoinStdtCmp from './components/JoinStdtCmp';
import SearchIdCmp from './components/SearchIdCmp';
import SearchPwCmp from './components/SearchPwCmp';

import RuleListCmp from './components/stdt/RuleListCmp';
import RuleInfoListCmp from './components/stdt/RuleInfoListCmp';
import RuleDetailListCmp from './components/stdt/RuleDetailListCmp';
import MyInfoCmp from './components/stdt/MyInfoCmp';

import UsrMainCmp from './components/usr/UsrMainCmp';
import StdtListCmp from './components/usr/StdtListCmp';
import StdtSearchCmp from './components/usr/StdtSearchCmp';
import StdtRuleHistoryCmp from './components/usr/StdtRuleHistoryCmp';
import NoticeCmp from './components/usr/NoticeCmp';
import NoticeArticleCmp from './components/usr/NoticeArticleCmp';
import NoticeRegistCmp from './components/usr/NoticeRegistCmp';
import StdtCnslHistoryCmp from './components/usr/StdtCnslHistoryCmp';
import RuleHistoryCmp from './components/usr/RuleHistoryCmp';
import RuleRptCmp from './components/usr/RuleRptCmp';
import RuleSearchCmp from './components/usr/RuleSearchCmp';
import DeductListCmp from './components/usr/DeductListCmp';
import DeductSearchCmp from './components/usr/DeductSearchCmp';
import UpdatePwdCmp from './components/usr/UpdatePwdCmp';
import StdtRuleInfoCmp from './components/usr/StdtRuleInfoCmp';
import StdtInfoCmp from './components/usr/StdtInfoCmp';
import StdtNoticeCmp from './components/stdt/NoticeCmp';
import StdtNoticeArticleCmp from './components/stdt/NoticeArticleCmp';

function App() {
  return (
    <>
      <Router>
        <Route path="/" exact component={MainCmp} />
        <Route path="/Terms" exact component={TermsCmp} />
        <Route path="/Private" exact component={PrivateCmp} />
        <Route path="/JoinStdt" exact component={JoinStdtCmp} />
        <Route path="/login/:userGu" exact component={LoginCmp} />
        <Route path="/SearchId" exact component={SearchIdCmp} />
        <Route path="/SearchPw" exact component={SearchPwCmp} />

        <Route path="/stdt/ruleList" exact component={RuleListCmp} />
        <Route path="/stdt/ruleInfoList" exact component={RuleInfoListCmp} />
        <Route path='/stdt/ruleDetailList/:clCd' exact component={RuleDetailListCmp} />
        <Route path="/stdt/myInfo" exact component={MyInfoCmp} />
        <Route path="/stdt/notice" exact component={StdtNoticeCmp} />
        <Route path="/stdt/noticeArticle/:bbsId/:nttId" exact component={StdtNoticeArticleCmp} />

        <Route path="/menuList" exact component={UsrMainCmp} />
        <CacheRoute cacheKey="stdtListCachce" path="/usr/stdtList" exact component={StdtListCmp} />
        <Route path="/usr/stdtSearch" exact component={StdtSearchCmp} />
        <CacheRoute cacheKey="stdtRuleHistoryCachce" path="/usr/stdtRuleHistory/:stdCd" exact component={StdtRuleHistoryCmp} />
        <CacheRoute cacheKey="noticeCachce" path="/usr/notice/:bbsId" exact component={NoticeCmp} />
        <Route path="/usr/noticeArticle/:bbsId/:nttId" exact component={NoticeArticleCmp} />
        <Route path="/usr/noticeRegist/:bbsId/:nttId" exact component={NoticeRegistCmp} />
        <CacheRoute cacheKey="newsCachce" path="/usr/upnews/:bbsId" exact component={NoticeCmp} />
        <CacheRoute cacheKey="qnaCachce" path="/usr/qna/:bbsId" exact component={NoticeCmp} />
        <Route path="/usr/stdtCnslHistory/:stdCd" exact component={StdtCnslHistoryCmp} />
        <CacheRoute cacheKey="ruleHistoryCachce" path="/usr/ruleHistory" exact component={RuleHistoryCmp} />
        <CacheRoute cacheKey="ruleRptCachce" path="/usr/ruleRpt" exact component={RuleRptCmp} />
        <Route path="/usr/ruleSearch" exact component={RuleSearchCmp} />
        <Route path="/usr/deductList" exact component={DeductListCmp} />
        <Route path="/usr/deductSearch" exact component={DeductSearchCmp} />
        <Route path="/usr/updatePwd" exact component={UpdatePwdCmp} />
        <Route path="/usr/ruleInfo" exact component={StdtRuleInfoCmp} />
        <Route path="/usr/stdtInfo" exact component={StdtInfoCmp} />
        <CacheRoute cacheKey="noticeSchoolCachce" path="/usr/notice/school/:bbsId" exact component={NoticeCmp} />
      </Router>
    </>
  );
}

export default App;